import { createAsyncActionTypes } from '../../util/createLifeomicActionTypes';

export default createAsyncActionTypes([
  'FETCH_CLIENTS',
  'DELETE_CLIENT',
  'DELETE_CLIENT_SUCCESS',
  'CREATE_CLIENT',
  'UPDATE_CLIENT',
]);
